// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TCianApiSiteV1GetRegionsModel, IMappers, TCianApiSiteV1GetRegionsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRegionsResponseSchema52 } from '../../../../entities/schemas/GetRegionsResponseSchema52';
import type { IErrorResponseSchema53 } from '../../../../entities/schemas/ErrorResponseSchema53';

export function createCianApiSiteV1GetRegionsModel(): TCianApiSiteV1GetRegionsModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/get-regions/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface ICianApiSiteV1GetRegionsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchCianApiSiteV1GetRegions<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: ICianApiSiteV1GetRegionsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1GetRegionsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1GetRegionsModel(),
    config,
  )) as FetchResponse<TCianApiSiteV1GetRegionsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRegionsResponseSchema52, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema53, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1GetRegionsResponse>;
}
